import { FormFieldType } from '@/shared/types/enum';
import { ModelNamePick } from '@/shared/types/model';

export const CUSTOM_FIELDS_DEFAULT_TYPE = FormFieldType.Text;
export const CUSTOM_FIELDS_COUNT = 10;

export type HasCustomFields = {
  customField1?: string | null;
  customField2?: string | null;
  customField3?: string | null;
  customField4?: string | null;
  customField5?: string | null;
  customField6?: string | null;
  customField7?: string | null;
  customField8?: string | null;
  customField9?: string | null;
  customField10?: string | null;
};

export type CustomFieldName = keyof HasCustomFields;

export const CustomFieldNames: CustomFieldName[] = [
  'customField1',
  'customField2',
  'customField3',
  'customField4',
  'customField5',
  'customField6',
  'customField7',
  'customField8',
  'customField9',
  'customField10',
];

export const CustomFieldRegex = /^customField(\d+)$/;

export type CustomFieldModelName = ModelNamePick<'Organisation' | 'Individual' | 'Task'>;

export const CustomFieldModelNames: CustomFieldModelName[] = ['Organisation', 'Individual', 'Task'];

export type CustomFieldIndex = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10';

export type CustomFieldSettings = Partial<
  Record<
    CustomFieldModelName,
    Partial<
      Record<
        CustomFieldIndex,
        {
          name?: string;
          type?: FormFieldType;
          decimalPoints?: number;
          sensitive?: boolean;
          options?: string[];
        }
      >
    >
  >
>;

export type FlatCustomFieldSettings = {
  [M in CustomFieldModelName as `${M}${CustomFieldIndex}Name`]?: string;
} & {
  [M in CustomFieldModelName as `${M}${CustomFieldIndex}Type`]?: FormFieldType;
} & {
  [M in CustomFieldModelName as `${M}${CustomFieldIndex}Dp`]?: number;
} & {
  [M in CustomFieldModelName as `${M}${CustomFieldIndex}Sensitive`]?: boolean;
} & {
  [M in CustomFieldModelName as `${M}${CustomFieldIndex}Options`]?: string;
};
